import { Stack } from 'braid-design-system';
import type React from 'react';

import { BUCKETS } from 'src/stores/JobApplicationStore/types';

import type { ApplicationStatusFacets } from '../utils/getStatusFacetsFromQueryData';

import { StatusFolderButtonMobile } from './StatusFolderButtonMobile';

interface StatusFolderButtonsMobileProps {
  selectedStatusFolder: BUCKETS | null;
  statusFacets: ApplicationStatusFacets;
  onClickStatusFolder: (bucket: BUCKETS) => void;
}

export const StatusFolderButtonsMobile: React.FC<
  StatusFolderButtonsMobileProps
> = ({ selectedStatusFolder, onClickStatusFolder, statusFacets }) => (
  <Stack space="xsmall">
    <StatusFolderButtonMobile
      key="mobile-status-folder-inbox"
      count={statusFacets.inboxCount}
      statusFolder={BUCKETS.INBOX}
      selected={selectedStatusFolder === BUCKETS.INBOX}
      newCount={statusFacets.newCount}
      onClick={() => {
        onClickStatusFolder(BUCKETS.INBOX);
      }}
    />
    <StatusFolderButtonMobile
      key="mobile-status-folder-prescreen"
      count={statusFacets.prescreenCount}
      statusFolder={BUCKETS.PRESCREEN}
      selected={selectedStatusFolder === BUCKETS.PRESCREEN}
      newCount={null}
      onClick={() => {
        onClickStatusFolder(BUCKETS.PRESCREEN);
      }}
    />
    <StatusFolderButtonMobile
      key="mobile-status-folder-shortlist"
      count={statusFacets.shortlistCount}
      statusFolder={BUCKETS.SHORTLIST}
      selected={selectedStatusFolder === BUCKETS.SHORTLIST}
      newCount={null}
      onClick={() => {
        onClickStatusFolder(BUCKETS.SHORTLIST);
      }}
    />
    <StatusFolderButtonMobile
      key="mobile-status-folder-interview"
      count={statusFacets.interviewCount}
      statusFolder={BUCKETS.INTERVIEW}
      selected={selectedStatusFolder === BUCKETS.INTERVIEW}
      newCount={null}
      onClick={() => {
        onClickStatusFolder(BUCKETS.INTERVIEW);
      }}
    />
    <StatusFolderButtonMobile
      key="mobile-status-folder-offer"
      count={statusFacets.offerCount}
      statusFolder={BUCKETS.OFFER}
      selected={selectedStatusFolder === BUCKETS.OFFER}
      newCount={null}
      onClick={() => {
        onClickStatusFolder(BUCKETS.OFFER);
      }}
    />
    <StatusFolderButtonMobile
      key="mobile-status-folder-accept"
      count={statusFacets.acceptCount}
      statusFolder={BUCKETS.ACCEPT}
      selected={selectedStatusFolder === BUCKETS.ACCEPT}
      newCount={null}
      onClick={() => {
        onClickStatusFolder(BUCKETS.ACCEPT);
      }}
    />
    <StatusFolderButtonMobile
      key="mobile-status-folder-not_suitable"
      count={statusFacets.rejectedCount}
      statusFolder={BUCKETS.NOT_SUITABLE}
      selected={selectedStatusFolder === BUCKETS.NOT_SUITABLE}
      newCount={null}
      onClick={() => {
        onClickStatusFolder(BUCKETS.NOT_SUITABLE);
      }}
    />
  </Stack>
);
